import { Box, Text, Tooltip } from '@radix-ui/themes';
import { textPropDefs } from '@radix-ui/themes/dist/cjs/components/text.props';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';

function RenderTooltip({ content, showTooltip, children }) {
  if (!showTooltip) return children;
  return <Tooltip content={content}>{children}</Tooltip>;
}

RenderTooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  showTooltip: PropTypes.bool,
  children: PropTypes.node,
};

const StyledText = styled(Text)`
  ${props =>
    props.whiteSpace &&
    css`
      white-space: ${props.whiteSpace};
    `}
`;

function TextWithTooltip({ children, maxWidth = '150px', ...rest }) {
  const ref = useRef();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (ref.current) {
        setShowTooltip(ref.current.offsetWidth < ref.current.scrollWidth);
      }
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <RenderTooltip
      content={children}
      showTooltip={showTooltip}
    >
      <Box
        maxWidth={maxWidth}
        asChild
      >
        <StyledText
          truncate
          {...rest}
          ref={ref}
        >
          {children}
        </StyledText>
      </Box>
    </RenderTooltip>
  );
}

TextWithTooltip.propTypes = {
  ...textPropDefs,
  maxWidth: PropTypes.number,
  children: PropTypes.node,
  whiteSpace: PropTypes.string,
};

export default TextWithTooltip;
